import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["agencySelect", "agencyNameContainer", "agencyNameField", "agencyIdNilField"]

  connect() {
    this.toggleAgencyName()
  }

  toggleAgencyName() {
    const selectedAgency = this.agencySelectTarget.value
    const requiresAgencyName = selectedAgency === "other"

    this.agencyNameContainerTarget.classList.toggle("d-none", !requiresAgencyName)
    this.agencyNameFieldTarget.required = requiresAgencyName
    this.agencyIdNilFieldTarget.disabled = !requiresAgencyName

    if (!requiresAgencyName) {
      this.agencyNameFieldTarget.value = ""
    }
  }
}
